export default __webpack_public_path__ + "static/whiteclaw-logo-540x540-d03a8a2a4982625b1248f319444da03e.webp";